import { useState, useEffect, useContext } from "react";
import styles from "./comunicados.module.css";
import Sidebar from "../../Components/Sidebar";
import Editor from "../../Components/Editor";
import MiniEditor from "../../Components/MiniEditor";
import api from "../../api";
import { AuthContext } from "../../Context/AuthContext";
import { useNavigate } from 'react-router-dom';



function toDDMMYYYY(iso) {
    if (!iso) return null;
    const [y, m, d] = iso.split("-");
    return `${d}/${m}/${y}`;
}

export default function NovoComunicados() {

    const navigate = useNavigate();

    const [titulo, setTitulo] = useState("");
    const [subtitulo, setSubtitulo] = useState("");
    const [conteudo, setConteudo] = useState("");
    const [imagem, setImagem] = useState(null);
    const [preview, setPreview] = useState(null);
    const [tipoPublicacao, setTipoPublicacao] = useState("agora");
    const [data, setData] = useState("");
    const [hora, setHora] = useState("");
    const [setor, setSetor] = useState("Comunicação Interna");
    const [grupos, setGrupos] = useState([]);
    const [grupo, setGrupo] = useState("0");
    const [briefing, setBriefing] = useState("");
    const [loadingIA, setLoadingIA] = useState(false);
    const [dataArquivamento, setDataArquivamento] = useState("");

    const { user } = useContext(AuthContext);




    const setoresMock = [
        "Comunicação Interna"
    ];

    function handleImagem(e) {

        const file = e.target.files[0];

        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            setImagem(reader.result); // base64
        };

        reader.readAsDataURL(file);
        setPreview(URL.createObjectURL(file));

    }

    async function gerarComIA() {
        if (!briefing.trim()) return;
        try {
            setLoadingIA(true);
            const res = await api.post('/portal/ia/comunicado', { descricao: briefing });
            const { titulo: t, subtitulo: s, conteudo: c } = res.data;
            if (t) setTitulo(t);
            if (s) setSubtitulo(s);
            if (c) setConteudo(c);
        } catch (error) {
            alert('Erro ao gerar comunicado com IA: ' + error);
        } finally {
            setLoadingIA(false);
        }
    }

    async function salvar() {

        const codope = user.codope;
        const dataPadrao = new Date().toISOString();

        const payload = {
            titulo,
            subtitulo,
            conteudo,
            grupo,
            setor,
            imagem,
            tipoPublicacao,
            data: data || dataPadrao,
            hora,
            codope,
            dataArquivamento: dataArquivamento ? toDDMMYYYY(dataArquivamento) : null,
        };

        try {

            await api.post('/portal/comunicado/', payload);



        } catch (error) {

            alert('Erro ao salvar comunicado : ' + error)

        } finally {

            navigate('/home');
        }

    }


    async function CarregarGrupos() {

        try {


            const response = await api.get(`/portal/grupos/?codgru=0`)

            const data = response.data

            setGrupos(data)

        } catch (error) {

            alert("Erro ao conectar com servidor : " + error)

        } finally {


        }

    }

    useEffect(() => {
        CarregarGrupos();
    }, [])

    return (

        <div className={styles.layout}>

            <Sidebar />

            <div className={styles.main}>

                <div className={styles.content}>

                    <div className={styles.pageHeader}>
                        <div>
                            <span className={styles.pageLabel}>Comunicação</span>
                            <h1 className={styles.pageTitle}>Novo Comunicado</h1>
                        </div>
                    </div>

                    {/* PAINEL DE IA 
                    <div className={styles.iaPanel}>
                        <div className={styles.iaPanelHeader}>
                            <span className={styles.iaIcone}>✨</span>
                            <div>
                                <h3>Gerar com Inteligência Artificial (Demo)</h3>
                                <p>Descreva o comunicado em poucas palavras e a IA cria o conteúdo completo para você.</p>
                            </div>
                        </div>
                        <textarea
                            className={styles.iaBriefing}
                            placeholder='Ex: "Reunião obrigatória de segurança na sexta-feira às 14h no auditório principal"'
                            value={briefing}
                            onChange={e => setBriefing(e.target.value)}
                            rows={3}
                        />
                        <div className={styles.iaRodape}>
                            <button
                                className={styles.btnGerarIA}
                                onClick={gerarComIA}
                                disabled={loadingIA || !briefing.trim()}
                            >
                                {loadingIA ? (
                                    <><span className={styles.iaSpinner} /> Gerando...</>
                                ) : (
                                    <>✨ Gerar comunicado</>
                                )}
                            </button>
                            {loadingIA && (
                                <span className={styles.iaHint}>A IA está criando seu comunicado, aguarde...</span>
                            )}
                        </div>
                    </div>*/}

                    <div className={styles.container}>

                        {/* FORM */}

                        <div className={styles.formCard}>

                            <div className={styles.formGroup}>
                                <label>Título</label>
                                <MiniEditor
                                    value={titulo}
                                    onChange={setTitulo}
                                    singleLine
                                />
                            </div>

                            <div className={styles.formGroup}>
                                <label>Subtítulo</label>
                                <MiniEditor
                                    value={subtitulo}
                                    onChange={setSubtitulo}
                                />
                            </div>

                            <div className={styles.formGroup}>

                                <label>Conteúdo do comunicado</label>

                                <Editor
                                    value={conteudo}
                                    onChange={setConteudo}
                                />

                            </div>

                            <div className={styles.formGroup}>
                                <label>Setor Reponsável</label>

                                <select
                                    value={setor}
                                    onChange={(e) => setSetor(e.target.value)}
                                >


                                    {setoresMock.map((s) => (
                                        <option value={s}>{s}</option>
                                    ))}

                                </select>

                            </div>

                            <div className={styles.formGroup}>
                                <label>Grupo Envio</label>

                                <select
                                    value={grupo}
                                    onChange={(e) => setGrupo(e.target.value)}

                                >
                                    <option value="0">Todos</option>
                                    {grupos.map((s) => (
                                        <option value={s.codgru}>{s.nomgru}</option>
                                    ))}
                                </select>

                            </div>

                            <div className={styles.formGroup}>
                                <label>Imagem da comunicação</label>

                                <input
                                    type="file"
                                    onChange={handleImagem}
                                />

                            </div>

                            

                            <div className={styles.formGroup}>

                                <label>Publicação</label>

                                <div className={styles.radioGroup}>

                                    <label>
                                        <input
                                            type="radio"
                                            checked={tipoPublicacao === "agora"}
                                            onChange={() => setTipoPublicacao("agora")}
                                        />
                                        Publicar agora
                                    </label>

                                    <label>
                                        <input
                                            type="radio"
                                            checked={tipoPublicacao === "agendado"}
                                            onChange={() => setTipoPublicacao("agendado")}
                                        />
                                        Agendar
                                    </label>

                                </div>

                            </div>

                            


                            {tipoPublicacao === "agendado" && (

                                <div className={styles.schedule}>

                                    <div className={styles.formGroup}>
                                        <label>Data</label>
                                        <input
                                            type="date"
                                            value={data}
                                            onChange={(e) => setData(e.target.value)}
                                        />
                                    </div>

                                    <div className={styles.formGroup}>
                                        <label>Hora</label>
                                        <input
                                            type="time"
                                            value={hora}
                                            onChange={(e) => setHora(e.target.value)}
                                        />
                                    </div>

                                </div>

                            )}

                            <div className={styles.arquivamentoGroup}>
                                <div className={styles.arquivamentoHeader}>
                                    <span>📦</span>
                                    <label>Data de arquivamento</label>
                                </div>
                                <input
                                    type="date"
                                    value={dataArquivamento}
                                    onChange={e => setDataArquivamento(e.target.value)}
                                    className={styles.arquivamentoInput}
                                />
                                <small className={styles.arquivamentoHint}>
                                    Opcional · o comunicado será arquivado automaticamente nessa data.
                                </small>
                            </div>

                            <button
                                className={styles.saveButton}
                                onClick={salvar}
                            >

                                Publicar comunicado

                            </button>

                        </div>


                        {/* PREVIEW */}

                        <div className={styles.previewCard}>

                            <h3>Preview do comunicado</h3>

                            <div className={styles.previewPost}>



                                <div className={styles.previewContent}>

                                    {setor && (
                                        <span className={styles.previewSetor}>
                                            {setor}
                                        </span>
                                    )}

                                    <div
                                        className={styles.previewTitulo}
                                        dangerouslySetInnerHTML={{
                                            __html: titulo || "<p>Título do comunicado</p>"
                                        }}
                                    />

                                    <div
                                        className={styles.previewSubtitulo}
                                        dangerouslySetInnerHTML={{
                                            __html: subtitulo || "<p>Subtítulo aparecerá aqui</p>"
                                        }}
                                    />

                                    <div
                                        className={styles.previewTexto}
                                        dangerouslySetInnerHTML={{
                                            __html: conteudo || "<p>Conteúdo aparecerá aqui</p>"
                                        }}

                                    />

                                    {preview && (
                                        <img src={preview} alt="preview" />
                                    )}



                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    )
}